import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap } from 'rxjs/operators';
import { SuccessAlert } from '@shared/alert';
import { Injectable } from '@angular/core';
import {
  sharedResourcesAddSuccess,
  sharedResourcesLoad,
  sharedResourcesLoadSuccess,
  sharedResourcesRemoveSuccess,
  sharedResourcesStoreLoaded,
} from 'mojo-share-resource';
import { sharedResourcesStoreCurrent } from './shared-resources.actions';
import { TeamRole } from '@shared';

@Injectable()
export class SharedResourcesEffects {
  teamMembersSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sharedResourcesAddSuccess, sharedResourcesRemoveSuccess),
      concatMap(({ payload, resourceType }) => [
        new SuccessAlert('Your changes have been saved'),
        sharedResourcesLoad({ resourceId: payload.id, resourceType }),
      ]),
    ),
  );

  teamMembersLoadSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sharedResourcesLoadSuccess),
      concatMap(({ resourceId, resourceType, teamMembers }) => {
        teamMembers.forEach(
          (teamMember) =>
            (teamMember.role = teamMember.role ? teamMember.role : TeamRole.regularRecruiter),
        );
        return [
          sharedResourcesStoreCurrent({
            resourceId,
            resourceType,
            teamMembers,
          }),
        ];
      }),
    ),
  );

  constructor(private actions$: Actions) {}
}
